export enum VisitMetricType {
  DiseaseView = 'diseaseView',
  DiseaseDownload = 'diseaseDownload',
  FundView = 'fundView',
  FundsView = 'fundsView',
  FundsSearch = 'fundsSearch',
  Visit = 'visit',
  PageView = 'pageView',
  FundApplicationUrlClick = 'fundApplicationUrlClick',
  FundWebsiteUrlClick = 'fundWebsiteUrlClick',
}
